<template>
  <a-layout>
    <a-card :bordered='false'>
      <a-button size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回
      </a-button>
      <span class="ml15 card_title" >{{$route.query.type == 'add' ? '创建':'编辑'}}扫码活动</span>
    </a-card>
    <a-card :bordered="false">
      <a-steps v-model:current="current" type="navigation" size="small" :style="{
            marginBottom: '20px',
            boxShadow: '0px -1px 0 0 #e8e8e8 inset',
          }">
        <a-step status="finish" :disabled="type!='edit'" :title="$route.query.type=='add'?'创建活动':'编辑活动'" />
        <a-step status="finish" :disabled="type!='edit'" title="设置二维码范围" />
      </a-steps>
      <div class="content   " v-show="current == 0">
        <setpsOne ref="one" v-on:setpsOneDone="setpsOneDone" :activity_id="activity_id" v-on:template_type="tempalteTypeChange" />
      </div>
      <div class="content   "  v-if="current == 1">
        <setpsTwo ref="two" :activity_id="activity_id" v-on:setpsTwoProvide="setpsTwoProvide"  v-on:setpsTwoNext="setpsTwoNext"/>
      </div>
    </a-card>
  </a-layout>
</template>
<script>
import { inject, onMounted, ref,provide} from "vue";
import { LeftOutlined } from "@ant-design/icons-vue";
import setpsOne from "./components/setpsOne/index";
import setpsTwo from "./components/setpsTwo/index";
export default {
  components: { setpsOne, setpsTwo, LeftOutlined },
  setup() {
    // 第几步
    const current = ref(0);
    // 活动ID
    const activity_id = ref(null);
    const $route = inject("$route");
    const one = ref();
    const two=ref()
    const tree=ref()
    // 第一步开始
    const setpsOneDone = (data) => {
      activity_id.value = data.activity_id || activity_id.value;
          // 注入依赖
      provide('activity_id',activity_id.value)
      current.value++;
      setpsTwoDetail()
    };
    // 获取详情
    const setpsOneDetail=()=>{
      one.value.detail();
    }
    const tempalteTypeChange=(type)=>{
      sessionStorage.setItem('template_type',type)
    }
    // 第一步结束
    // 第二步开始
    var setpsTwoDetail=()=>{
      two.value && two.value.detail();
    }
         // 获取详情
    const setpsTreeDetail=()=>{
     tree.value&& tree.value.detail();
      tree.value&& tree.value.getList();
    }
    // 下一步
    const setpsTwoNext=()=>{
       current.value++;
       setpsTreeDetail()
    }
    // 上一步
    const setpsTwoProvide=()=>{
       current.value--;
       setpsOneDetail()
    }
    // 第二步结束
    if($route.query.activity_id) {
      activity_id.value=$route.query.activity_id
      // 注入依赖
      provide('activity_id',activity_id.value)
    }
    onMounted(() => {
      if($route.query.activity_id) {
        setpsOneDetail()
      }
    });
    // 第三步
    // 下一步
    const setpsTreeNext=()=>{
       current.value=3;
    }
    // 上一步
    const setpsTreeProvide=()=>{
       current.value--;
       setpsTwoDetail()
    }
    // 第三步结束

    // 第四步
    const setpsFourProvide=()=>{
       current.value--;
    }

    // const changeSteps
    
    return {
      current,
      activity_id,
      one,
      setpsOneDone,
      two,
      setpsTwoNext,
      setpsTwoProvide,
      setpsTreeNext,
      setpsTreeProvide,
      setpsFourProvide,
      tree,
      tempalteTypeChange
    };
  },
};
</script>